/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { withStyles } from "@mui/styles";
import { createStyles, styled } from "@mui/material/styles";
import {
  AppBar,
  AppBarProps,
  Avatar,
  Breadcrumbs,
  CssBaseline,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { Box } from "@mui/system";
import { Vocabulary } from "../Utils/Vocabulary";
import { Logout, Settings, AccountCircle } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { MenuContext } from "../Context/menuContext";
import { useNavigate } from "react-router-dom";
import { BreadCrumbsContext } from "../Context/breadCrumbsContext";
import style from "./Header.module.scss";
import moment from "moment";
import { LocalUrlEnum, logout } from "../Utils/Utils";
import { roles } from "../Utils/Constants";
import useMediaQuery from "@mui/material/useMediaQuery";

type Props = {
  classes: any;
};

interface CustomAppBarProps extends AppBarProps {
  open?: boolean;
}

function Header(props: Props) {
  const { classes } = props;
  const menuContext = useContext(MenuContext);
  const [showUserOptions, setShowUserOptions] = useState(null);
  const breadCrumbsContext = useContext(BreadCrumbsContext);
  const navigate = useNavigate();
  const localStorageRole = localStorage.getItem("role");
  const email = localStorage.getItem("email")
    ? localStorage.getItem("email")
    : "";
  const matches = useMediaQuery("(max-width:850px)");
  // On mobile every role uses either a bottom nav (customer) or a
  // temporary overlay drawer (admin/staff) — neither should push/shrink
  // the AppBar the way a permanent desktop sidebar does.
  const drawerWidth = matches ? 0 : 240;

  const CustomAppBar = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })<CustomAppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 30,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));
  /**
   *
   */
  const menuHandleClick = () => {
    menuContext.setOpen(!menuContext.open);
  };

  /**
   *
   */
  function handleCloseUserMenu() {
    setShowUserOptions(null);
  }

  /**
   *
   * @param event
   */
  function handleOpenUserMenu(event: any) {
    setShowUserOptions(event.currentTarget);
  }

  return (
    <Box className={style.headerBox}>
      <CssBaseline />
      <CustomAppBar
        position="static"
        className={classes.container}
        open={menuContext.open}
      >
        <Toolbar className={style.headerToolbar}>
          <div className={style.headerToolbarDiv}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{
                mr: 2,
                ...(menuContext.open && { display: "none" }),
              }}
              onClick={menuHandleClick}
            >
              <Avatar className={classes.avatar}>
                <MenuIcon />
              </Avatar>
            </IconButton>
            <div className={classes.image}>
              <img src={"/yzzy-logo.png"} alt="YZZY" style={{height:"25px"}} />
            </div>
            <div>
              <Breadcrumbs separator="/" className={style.headerBreadcrumbs}>
                {breadCrumbsContext.breadCrumbs.map(
                  (name: any, index: number) => {
                    if (index === breadCrumbsContext.breadCrumbs.length - 1)
                      return (
                        <Link
                          key={`${name}_${index}`}
                          underline="none"
                          color="inherit"
                        >
                          {Object.prototype.hasOwnProperty.call(
                            Vocabulary,
                            name
                          )
                            ? Vocabulary[name]
                            : name}
                        </Link>
                      );

                    return (
                      <Link
                        key={`${name}_${index}`}
                        underline="hover"
                        color="inherit"
                        href={
                          name === "orders"
                            ? `/${name}?page=1?perPage=20?filter=Niciun filtru?sort=createdAt,desc?startDate=${moment()
                                .subtract(14, "d")
                                .format(
                                  "YYYY-MM-DD"
                                )}?endDate=${moment().format("YYYY-MM-DD")}`
                            : `/${name}?page=1?perPage=10`
                        }
                      >
                        {Object.prototype.hasOwnProperty.call(Vocabulary, name)
                          ? Vocabulary[name]
                          : name}
                      </Link>
                    );
                  }
                )}
              </Breadcrumbs>
            </div>
          </div>
          <IconButton
            id="userButton"
            size="large"
            edge="end"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={(event) => {
              handleOpenUserMenu(event);
            }}
          >
            <Avatar className={classes.avatar}>
              {email ? (
                email.charAt(0).toUpperCase()
              ) : (
                <AccountCircle fontSize="large" />
              )}
            </Avatar>
          </IconButton>
        </Toolbar>
        <Box>
          <Menu
            anchorEl={() => (document.getElementById("userButton") as Element) || showUserOptions}
            sx={{ mt: "50px" }}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(showUserOptions)}
            onClose={handleCloseUserMenu}
          >
            {localStorageRole !== roles.customer ? (
              <MenuItem
                onClick={() => {
                  navigate(LocalUrlEnum.settings);
                }}
              >
                <Settings fontSize="large" className={style.menuSettings} />
                <Typography variant="h6">{Vocabulary.settings}</Typography>
              </MenuItem>
            ) : null}
            <MenuItem
              onClick={() => {
                handleCloseUserMenu();
                logout();
              }}
            >
              <Logout fontSize="large" className={style.menuSettings} />
              <Typography variant="h6">{Vocabulary.logout}</Typography>
            </MenuItem>
          </Menu>
        </Box>
      </CustomAppBar>
    </Box>
  );
}

const styles = (theme: any) =>
  createStyles({
    container: {
      width: "100%",
      backgroundColor: `${theme.palette.whiteColor?.main} !important`,
      boxShadow: `1px 3px 10px ${theme.palette.blackColor?.main} `,
      [theme.breakpoints.down("lg")]: {},
    },
    image: {
      marginTop: "10px",
    },
    avatar: {
      backgroundColor: `${theme.palette.dashboard?.main} !important`,
    },
  });

export default withStyles(styles, { withTheme: true })(Header);
